const DEFAULT_WEBSITE_URL = "http://localhost:3000";
const VERCEL_BYPASS = import.meta.env.VITE_VERCEL_PROTECTION_BYPASS;
const BILLING_API_URL = import.meta.env.VITE_BILLING_API_URL ?? `${DEFAULT_WEBSITE_URL}/api/billing`;
const LOGIN_REDIRECT_URL = import.meta.env.VITE_LOGIN_REDIRECT_URL ?? `${DEFAULT_WEBSITE_URL}/login`;
const WEBSITE_BASE_URL = import.meta.env.VITE_WEBSITE_BASE_URL;

class _Urls {
  billing(...parts: string[]) {
    const baseUrl = WEBSITE_BASE_URL ? `${WEBSITE_BASE_URL}/api/billing` : BILLING_API_URL;
    const extendedUrl = [baseUrl, ...parts].join("/");
    if (VERCEL_BYPASS) {
      const url = new URL(extendedUrl);
      url.searchParams.set("x-vercel-protection-bypass", VERCEL_BYPASS);
      return url.toString();
    }
    return extendedUrl;
  }

  get login() {
    const baseLogin = WEBSITE_BASE_URL ? `${WEBSITE_BASE_URL}/login` : LOGIN_REDIRECT_URL
    const url = new URL(baseLogin);
    url.searchParams.set("redirect", window.location.href);
    return url.toString();
  }

  get demos() {
    return `${WEBSITE_BASE_URL ?? DEFAULT_WEBSITE_URL}/agentica#about`;
  }

  get termsOfUse() {
    return `${WEBSITE_BASE_URL ?? DEFAULT_WEBSITE_URL}/terms/terms-of-use`;
  }

  get privacyPolicy() {
    return `${WEBSITE_BASE_URL ?? DEFAULT_WEBSITE_URL}/terms/privacy-policy`;
  }
}

export const websiteUrls = new _Urls();
